var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { observable } from 'mobx';
import { deserialize, list, primitive, withDefault } from '../../../utils/serializr/serializr';
import { disgardOldValue } from '../../../utils/serializr/schema/middle/disgardOldValue';
import { actorFilterRegistry, aspectFilterRegistry } from '../../../registry/Registry';
import { resetOnCopy, resetOnCopy_id } from '../../../utils/serializr/schema/middle/resetOnCopy';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { str_replace } from '../../../utils/helper/helper_string';
export class AspectExp {
    id;
    parent;
    type = 'aspectexp';
    actorFilterKeys = observable.array(['none']);
    aspectFilterKeys = observable.array();
    priorityLifting = 10;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get trait() {
        return this.parent;
    }
    get app() {
        return this.trait.aspect.context.app;
    }
    get traitsToExport() {
        return this.trait.aspect.traits;
    }
    // @computed
    get actorFilterFunctions() {
        /*   if (this.actorFilterKeys.includes('readTask')) {
          setTimeout(
            action(() => {
              const index = this.actorFilterKeys.indexOf('readTask');
    
              if (index !== -1) {
                this.actorFilterKeys[index] = 'readtask';
              }
            }),
            2
          );
        } */
        return this.actorFilterKeys.map(filterKey => this.getActorFilterFromRegistry(filterKey));
    }
    getActorFilterFromRegistry(actorFilterKey) {
        const reg = actorFilterRegistry.registry_object[actorFilterKey];
        if (reg) {
            return reg.filter;
        }
        console.log('MISSING getActorFilter', actorFilterKey);
        return () => false;
    }
    // @computed
    get aspectFilterFunctions() {
        return this.aspectFilterKeys.map(aspectFilterKey => this.getAspectFilterFromRegistry(aspectFilterKey));
    }
    getAspectFilterFromRegistry(aspectFilterKey) {
        const reg = aspectFilterRegistry.getRegByKey(aspectFilterKey);
        if (reg) {
            return reg.filter;
        }
        return this.defaultAspectFilter(aspectFilterKey);
    }
    defaultAspectFilter(aspectFilterKey) {
        const multipleAspectNames = aspectFilterKey.split(',');
        if (multipleAspectNames.length > 1) {
            return ({ a }) => multipleAspectNames.includes(a.name);
        }
        if (aspectFilterKey.startsWith('%') && aspectFilterKey.endsWith('%')) {
            return ({ a }) => a.name.includes(str_replace('%', '', aspectFilterKey));
        }
        return ({ a }) => a.name === aspectFilterKey;
    }
    static fromSerialized(ser = {}) {
        return deserialize(AspectExp, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                id: withDefault(resetOnCopy(primitive, resetOnCopy_id), () => nanoid(6)),
                type: true,
                actorFilterKeys: list(primitive),
                aspectFilterKeys: disgardOldValue(list(primitive)),
                priorityLifting: true,
            },
        };
    }
}
__decorate([
    editable()
], AspectExp.prototype, "id", void 0);
__decorate([
    editable('shallow')
], AspectExp.prototype, "actorFilterKeys", void 0);
__decorate([
    editable('shallow')
], AspectExp.prototype, "aspectFilterKeys", void 0);
__decorate([
    editable()
], AspectExp.prototype, "priorityLifting", void 0);
__decorate([
    memoize
], AspectExp, "serializeInfo", null);
